/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ms } from './Ms';

class WxmsgTemplate extends Ms {
    constructor() {
        super();
        this.baseUrl += '/wxmsgTemplate';
    }

    data({ orgId, wxmsgUseCaseName, wxmsgTemplateName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            orgId,
            wxmsgUseCaseName,
            wxmsgTemplateName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then();
    }

    save({ id, orgId, wxmsgUseCase, wxmsgTemplateName, wxmsgContent, isAvailable } = {}) {
        return super.post('/save', {
            id,
            orgId,
            wxmsgUseCase,
            wxmsgTemplateName,
            wxmsgContent,
            isAvailable,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }
}

export default new WxmsgTemplate();
export { WxmsgTemplate };
